module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAATCAMAAABWWYYKAAAAV1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////+ORg7oAAAAHHRSTlMAERIiJSZFR0hKUl9uc3x9q6yys8jM0NHV5PLzdoJkZgAAAGxJREFUKM+9kcsSgCAIReldWtpDM6v//840cFFOLjsbFgfmMgBcCiFkXvjyQHI4b6rmjCFX1n85E5yaEBWUgcySY4AwUjYH6MnpBdHkBtfXfuR1EM855gPnojzPhnnre0/HuOOef98s9b/E3y9evSyJV50hiAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/piaoju.png
// module id = Rf56
// module chunks = 70